import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectPaper } from '../../../project-corpus/domain/types';

@Component({
  selector: 'app-paper-picker',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col gap-1">
      @for (p of papers(); track p.id) {
        <button
          type="button"
          class="text-left px-2 py-1 rounded border text-xs"
          [class.border-blue-500]="p.id === selectedId()"
          [class.bg-blue-50]="p.id === selectedId()"
          [class.border-slate-200]="p.id !== selectedId()"
          [class.opacity-50]="!p.hasPdf"
          [class.cursor-not-allowed]="!p.hasPdf"
          [disabled]="!p.hasPdf"
          [title]="p.hasPdf ? '' : 'No PDF available - upload one in the corpus'"
          (click)="select.emit(p)"
        >
          <span class="font-medium">{{ p.title || 'Untitled' }}</span>
          <span class="text-slate-500">
            {{ p.authors.length ? ' - ' + p.authors[0] : ''
            }}{{ p.year ? ' (' + p.year + ')' : '' }}
          </span>
          @if (!p.hasPdf) {
            <span class="text-slate-400"> - no PDF available</span>
          }
        </button>
      } @empty {
        <div class="text-xs text-slate-500 px-2 py-1">
          No uploaded PDFs to annotate yet. Upload a PDF in the corpus.
        </div>
      }
    </div>
  `,
})
export class PaperPickerComponent {
  readonly papers = input<ProjectPaper[]>([]);
  readonly selectedId = input<string | null>(null);
  readonly select = output<ProjectPaper>();
}
